import * as React from 'react'
import { Outlet, createRootRoute } from '@tanstack/react-router'
import { useStore } from '@/store'
import { useShallow } from 'zustand/shallow'
import { Toaster } from "@/components/ui/sonner"
import { useEffect } from 'react'
import { SidebarProvider } from "@/components/ui/sidebar"
import { AppSidebar } from "@/components/features/app-sidebar"

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  const { checkLoginStatus, curPage } = useStore(useShallow(state => ({
    checkLoginStatus: state.checkLoginStatus,
    curPage: state.curPage
  })))

  useEffect(() => {
    checkLoginStatus()
    const host = window.location.host;
    if (["app.mp2.in", "preprod-app.mp2.in"].includes(host)) {
      window.location.href = window.location.href.replace(".mp2.in", ".prorouting.in");
    }
  }, [])


  return (
    <SidebarProvider >
      <AppSidebar curPage={curPage}/>
      <React.Fragment>
        <Outlet />
        <Toaster position="bottom-center" richColors />
      </React.Fragment>
    </SidebarProvider>
  )
}
